;(function ( $ ) {

    /**
     *  chartTwoBars
     *  draws two bar charts, used for exhibitor tickets
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'chartTwoBars';
    var defaults = {
        maxHeight: 280,
        animationDuration: 400,
        easing: 'easeInOutCubic', // 'easeOutElastic'
        barWidth: 100,
        minValue: 20
    };

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {

        init: function () {
            this.data = this.parseDataTables();
            if ($(window).width() <= 767) {
                this.displayMode = 'mobile';
            } else {
                this.displayMode = 'default';
            }
            this.max = this.findMaxValue();
            this.heightRatio = this.settings.maxHeight / this.max;
            $(this.element).empty();
            this.$graphWrapper = $('<div class="graph-wrapper" />');
            $(this.element).append(this.$graphWrapper);
            $(this.element).find('.graph-wrapper').css('margin-top', '50px');
            this.renderGraph();
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            $(window).smartresize(function() {
                var lastMode = _this.displayMode;
                if ($(window).width() <= 767) {
                    _this.displayMode = 'mobile';
                } else {
                    _this.displayMode = 'default';
                }
                if (lastMode != _this.displayMode) {
                    $(_this.element).empty();
                    _this.$graphWrapper = $('<div class="graph-wrapper" />');
                    $(_this.element).append(_this.$graphWrapper);
                    $(_this.element).find('.graph-wrapper').css('margin-top', '50px');
                    _this.renderGraph();
                }
            });
        },

        parseDataTables: function() {
            var _this = this;
            var data = [];
            var dt;
            var keyVal;
            $(this.element).find('.graph-data-table').each(function(index, elem) {
                dt = {};
                dt.title = $(this).find('h3').text();
                dt.values = [];
                $(this).find('tr').each(function() {
                    keyVal = {
                        key: $(this).find('th').text(),
                        extra_caption: $(this).find('th').data('extra-caption'),
                        val: parseInt($(this).find('td').text()),
                        bgColorClass: $(this).data('bg-color-class'),
                        colorClass: $(this).data('color-class')
                    };
                    if ($(this).data('is-compound') === true) {
                       keyVal.isCompound = true;
                    }
                    if ($(this).data('parent')) {
                       keyVal.parentKey = $(this).data('parent');
                    }
                    dt.values.push(keyVal);
                });
                data.push(dt);
            });
            return data;
        },

        findMaxValue: function() {
            var max = this.settings.minValue;
            for (var i = 0; i < this.data.length; i++) {
                for (var j = 0; j < this.data[i].values.length; j++) {
                    if (this.data[i].values[j].val > max) {
                        max = this.data[i].values[j].val;
                    }
                }
            }
            return max;
        },

        renderGraph: function() {
            var _this = this;
            var data = _this.data[0];
            var $bar;
            var $barDivider;
            var $caption;
            var h;
            var z = 0;
            var compoundZ = 0;
            var bottomOffset = 120;
            var maxCompoundCaptionWidth = this.findMaxCompoundCaptionWidth(data);

            var barWidth;
            var labelBottom = -16;
            var $legend;
            for (var i = 0; i < data.values.length; i++) {
                if (i <= 1) { // first bar - background - max tickets
                    if ($(this.element).find('.bar-' + i).length) {
                        $bar = $(this.element).find('.bar-' + i);
                        $caption = $(this.element).find('.bar-caption-' + i);
                    } else {
                        $bar = $('<div class="bar bar-' + i + ' ' + data.values[i].bgColorClass + '" />');
                        $bar.css({
                            'width': this.settings.barWidth + 'px',
                            'height': 2,
                            'position': 'absolute',
                            'bottom': bottomOffset + 'px',
                            'left': 0 + ((this.settings.barWidth + 15) * i)
                        });
                        $(this.element).find('.graph-wrapper').append($bar);

                        $caption = $('<div class="bar-caption bar-caption-' + i + ' ' + data.values[i].colorClass + '" />');
                        $caption.append('<span class="huge"><span class="huge-text">' + data.values[i].val +
                            '</span><br /><span class="huge-caption">'+ data.values[i].key +'</span></span>');
                        $caption.css({
                            'width': this.settings.barWidth + 'px',
                            'position': 'absolute',
                            'bottom': labelBottom,
                            'left': 0 + ((this.settings.barWidth + 15) * i)
                        });
                        $(this.element).find('.graph-wrapper').append($caption);
                        if (data.values[i].extra_caption) {
                            var $extra_caption = $('<div class="bar-extra-caption bar-extra-caption-' + i + ' ' + data.values[i].colorClass + '" />');
                            $extra_caption.text(data.values[i].extra_caption);
                            $extra_caption.css({
                                'width': this.settings.barWidth + 20 + 'px',
                                'position': 'absolute',
                                'bottom': labelBottom + 12,
                                'left': 0
                            });
                            $(this.element).find('.graph-wrapper').append($extra_caption);
                            $(this.element).find('.bar-extra-caption-' + i).hide().delay(400 * (i + 1)).fadeIn(800);
                        }
                        if (this.max > 999) {
                            $caption.find('.huge-text').css({
                                'font-size': '250%'
                            });
                        }
                        if (this.max > 9999) {
                            $caption.find('.huge-text').css({
                                'font-size': '180%'
                            });
                        }
                        $(this.element).find('.bar-caption-' + i).hide().delay(400 * (i + 1)).fadeIn(800);
                    }
                    h = Math.round(data.values[i].val * this.heightRatio);
                    if (h < 2) h = 2;
                    $bar.animate({
                        'height': h
                    }, this.settings.animationDuration, this.settings.easing);
                } else { // stacked bars
                    // stacked bars - free & payed
                    var asterisks = '';
                    if (this.displayMode == 'mobile') {
                        for (var k = 1; k <= compoundZ + 1; k++) {
                            asterisks += '*';
                        }
                        if ($(this.element).find('.legend').length) {
                            $legend = $(this.element).find('.legend');
                        } else {
                            $legend = $('<div class="legend color-bar-grey"></div>');
                            $(this.element).append($legend);
                            $legend = $(this.element).find('.legend');
                        }
                    } else {
                        $(this.element).find('.legend').remove();
                    }
                    if (this.displayMode == 'mobile') {
                        $legend.append('<span>' + asterisks + ' ' + data.values[i].key + '</span>');
                    }
                    var minH = 2;
                    if (bottomOffset > 120) {
                        minH = 0;
                    }
                    if ($(this.element).find('.bar-' + i).length) {
                        $bar = $(this.element).find('.bar-' + i);
                    } else {
                        $bar = $('<div class="bar bar-' + i + ' ' + data.values[i].bgColorClass + '"><span class="value">' + asterisks + ' ' + data.values[i].val + '</span><span class="caption"></span></div>');
                        $(this.element).find('.graph-wrapper').append($bar);
                        $bar.css({
                            'width': this.settings.barWidth + 'px',
                            'height': minH,
                            'position': 'absolute',
                            'bottom': bottomOffset + 'px',
                            'left': this.settings.barWidth + 15
                        });
                        if (i == 2) {
                            $bar.css('background-color', 'transparent');
                        }

                        if (this.displayMode != 'mobile') {
                            $bar.find('.caption').text(data.values[i].key).addClass(data.values[i].colorClass);
                            if (data.values[i].val) {
                                $bar.find('.caption').delay(this.settings.animationDuration * 2).fadeIn(200);
                            }
                        }
                    }
                    h = Math.round(data.values[i].val * this.heightRatio) - 5;
                    if (h < 25) {
                        h = 25;
                    }
                    if (!data.values[i].val) {
                        h = minH;
                    }
                    if (h < minH) h = minH;
                    $bar.find('.value').text(asterisks + ' ' + data.values[i].val).hide();
                    if (i == 2 && data.values[1].val < data.values[2].val - 1) {
                        $bar.find('.value').css('color', $bar.find('.caption').css('color'));
                    }
                    if (i == 3 && data.values[3].val === 0) {
                        $bar.find('.value').css('color', $bar.find('.caption').css('color'));
                    }
                    $bar.animate(
                        {
                            'height': h,
                            'bottom': bottomOffset
                        },
                        this.settings.animationDuration,
                        this.settings.easing
                        /* jshint ignore:start */
                        ,
                        function() {
                            $(this).find('.value').fadeIn(200);
                            if ($(this).find('.value').text()) {
                                $(this).find('.caption').hide().fadeIn(200);
                            }
                        }
                        /* jshint ignore:end */

                    );
                    bottomOffset += h + 10;

                    if (!compoundZ && data.values[i].val) { // draw divider
                        $bar.find('span.value').addClass('first');
                        $bar.find('span.caption').addClass('first');
                        if ($(this.element).find('.bar-divider-' + i).length) {
                            $barDivider = $(this.element).find('.bar-divider-' + i);
                        } else {
                            $barDivider = $('<div class="bar-divider bar-divider-' + i + ' ' + data.values[i].bgColorClass + '" />');
                            $(this.element).find('.graph-wrapper').append($barDivider);
                            $barDivider.css({
                                'width': '0',
                                'height': '10px',
                                'border-bottom': '4px solid #fff',
                                'border-top': '4px solid #fff',
                                'position': 'absolute',
                                'bottom': bottomOffset - 10 + 'px',
                                'left': (this.settings.barWidth + 15) * (z + 1) + 'px'
                            });
                            $barDivider.animate({
                                'width': maxCompoundCaptionWidth + this.settings.barWidth - 2
                            }, this.settings.animationDuration, _this.settings.easing);
                        }
                        $barDivider.animate({
                            'bottom': bottomOffset - 10 + 'px'
                        }, this.settings.animationDuration, _this.settings.easing);
                    }
                    compoundZ++;
                }
            }
        },

        findMaxCompoundCaptionWidth: function(data) {
            var maxWidth = 0;
            if (this.displayMode == 'mobile') {
                return 2;
            }
            $(this.element).append('<div id="measure-bar" class="bar"><span class="caption"></span></div>');
            for (var i = 0; i < data.values.length; i++) {
                if (data.values[i].parentKey) {
                    $('#measure-bar').find('.caption').text(data.values[i].key);
                    if ($('#measure-bar').find('.caption').width() > maxWidth) {
                        maxWidth = $('#measure-bar').find('.caption').width();
                    }
                }
            }
            $('#measure-bar').remove();
            return maxWidth;
        },

    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
